export default __webpack_public_path__ + "b9695d9c139d2a1e53c499045dbe5050.png";